import { defineMessage } from 'services/localization';

export const messages = {
    active: defineMessage('active_2'),
    editParticipantsTitleText: defineMessage('change_approvers_in_this_step'),
    reassignRequestTitleText: defineMessage('reassign_the_request_to_another_approver'),
    reviewStep: defineMessage('review_step_2'),
    reviewed: defineMessage('reviewed'),
    sectionText: defineMessage('approval_workflow'),
    stepActiveText: defineMessage('active'),
    stepAutoApproved: defineMessage('there_are_no_approvers__epbrit_has_been_skipped'),
    stepNotStartedText: defineMessage('upcoming'),
    stepTooltipStatusActive: defineMessage('active_step_1'),
    stepTooltipStatusApproved: defineMessage('approved_1'),
    stepTooltipStatusLocked: defineMessage('locked_reason'),
    stepTooltipStatusLockedReasonApproved: defineMessage('request_approved'),
    stepTooltipStatusLockedReasonApprovedByAdmin: defineMessage('request_force_approved_by_company_administrator'),
    stepTooltipStatusLockedReasonApprovedExternally: defineMessage('request_approved_in_integrationname'),
    stepTooltipStatusLockedReasonCancelled: defineMessage('request_cancelled'),
    stepTooltipStatusLockedReasonCancelledByAdmin: defineMessage('request_cancelled_by_company_administrator'),
    stepTooltipStatusLockedReasonCancelledExternally: defineMessage('request_cancelled_in_integrationname'),
    stepTooltipStatusLockedReasonRejected: defineMessage('request_rejected'),
    stepTooltipStatusLockedReasonRejectedByAdmin: defineMessage('request_force_rejected_by_company_administrator'),
    stepTooltipStatusLockedReasonRejectedExternally: defineMessage('request_rejected_in_integrationname'),
    stepTooltipStatusRejected: defineMessage('rejected_1'),
    stepTooltipStatusUpcoming: defineMessage('upcoming_1'),
    stepTypeAnyOf: defineMessage('any_of'),
    stepTypeAnyOfCount: defineMessage('any_count_of_selected'),
    stepTypeDefault: defineMessage('all'),
    stepTypeText: defineMessage('approval_condition_type'),
};
